import {LOANS, LOANS_MODAL_STATES} from 'loans.module/common/domain/constants.loans';
import {MODALS} from 'common/domain/constants';
import {STATES} from 'common/domain/states';

class MyLoansCardController {
  constructor($translate, EventEmitter, LoansStatesService, $window, $state) {
    'ngInject';
    this.$translate = $translate;
    this.EventEmitter = EventEmitter;
    this.stateLiterals = LoansStatesService.getAll();
    this.isMobileApp = $window.innerWidth < 1024;
    this.state = $state;
  }

  $onInit() {
    this.housingLoan = this.loanObject.modalityCode === LOANS.ID_HR.SOCIAL_HOUSING_LOAN ||
      this.loanObject.modalityCode === LOANS.ID_HR.AGREEMENT_HOUSING_LOAN;

    this.$translate(this.stateLiterals[this.loanObject.statusCode]['text']).then((translation) => {
      this.currentStateLiteral = translation;
    });

    this.classIcon = this.stateLiterals[this.loanObject.statusCode]['icon'];
    this.numberAlerts = this.getNumberAlerts();
    this.hasAlerts = this.numberAlerts !== 0;

    if (this.hasAlerts) {
      this.sendLoanObject(this.loanObject);
    }

    this.messageAlert = false;
  }

  showDifferentOptions() {
    let event = this.EventEmitter({
      loan: this.loanObject,
    });

    this.onToggleOptions(event);
    this.sendLoanObject(this.loanObject);
  }

  sendLoanObject(loan) {
    this.onSelectOption(this.EventEmitter({
      loan: loan,
    }));
  }

  isOptionsForStatusCodeEmpty() {
    return this.loanObject.statusCode !== LOANS.STATES.ID.CANCELLED &&
      this.loanObject.statusCode !== LOANS.STATES.ID.IN_STUDIO &&
      this.loanObject.statusCode !== LOANS.STATES.ID.TRANSITIONAL_INTEGRATION;
  }

  showAmountPending() {
    return this.loanObject.statusCode === LOANS.STATES.ID.IN_FORCE;
  }

  showMonthlyFee() {
    return this.loanObject.statusCode === LOANS.STATES.ID.IN_FORCE;
  }

  getNumberAlerts() {
    let numberAlerts = 0;

    if (this.hasCadastralReferenceError()) {
      numberAlerts++;
    }

    if (this.hasJustificationError()) {
      numberAlerts++;
    }

    return numberAlerts;
  }

  showingMessageAlert() {
    if (this.filterActive) {
      this.hideMessageAlert();
    }

    return this.messageAlert;
  }

  showMessageAlert() {
    this.messageAlert = true;
    this.filterActive = false;
  }

  showOtherText() {
    return this.loanObject.statusCode === LOANS.STATES.ID.PENDING ||
      this.loanObject.statusCode === LOANS.STATES.ID.PENDING_SIGNATURE ||
      this.loanObject.statusCode === LOANS.STATES.ID.DENIED;
  }

  hideMessageAlert() {
    this.messageAlert = false;
  }

  loanHasBeenCancelledThisYear(loanCancellationDate) {
    const firstDayOfYear = this.getFirstDayOfCurrentYear();
    const cancellationDate = new Date(loanCancellationDate);
    return cancellationDate >= firstDayOfYear;
  }

  getFirstDayOfCurrentYear() {
    const currentYear = new Date().getFullYear();
    return new Date(`${currentYear}-1-1 01:00:00`);
  }

  loanHasBeenHiredAfter2009(loanGrantDate) {
    const firstDayOfYear09 = new Date('2009-1-1 01:00:00');
    const grantDate = new Date(loanGrantDate);
    return grantDate >= firstDayOfYear09;
  }

  hasCadastralReferenceError() {
    if (this.isAnnulated() || this.isDenied() || this.isCanceled() || this.isDisclaimer() || this.isRegressed()) {
      return false;
    }

    const cadastralReferenceEmpty = !this.loanObject.cadastralReference.cadastralReference;
    this.isDateGrantHigher = this.loanHasBeenHiredAfter2009(this.loanObject.grantDate);

    if (this.loanObject.statusCode === LOANS.STATES.ID.NOT_IN_FORCE) {
      this.isDateCancellationHigher = this.loanHasBeenCancelledThisYear(this.loanObject.cancellationDate);
      return this.housingLoan && this.isDateCancellationHigher && this.isDateGrantHigher && cadastralReferenceEmpty;
    }

    return (this.housingLoan && cadastralReferenceEmpty && this.isDateGrantHigher);
  }

  hasJustificationError() {
    return this.loanObject.justification === true;
  }

  isAnnulated() {
    return this.loanObject.originalStatusCode === LOANS.STATES.ID.ANNULATED;
  }

  isDenied() {
    return this.loanObject.statusCode === LOANS.STATES.ID.DENIED;
  }

  isCanceled() {
    return this.loanObject.originalStatusCode === LOANS.STATES.ID.CANCELLED;
  }

  isDisclaimer() {
    return this.loanObject.originalStatusCode === LOANS.STATES.ID.DISCLAIMER;
  }

  isRegressed() {
    return this.loanObject.originalStatusCode === LOANS.STATES.ID.REGRESSED;
  }

  openCadastralReference() {
    if (this.serviceClosed) {
      return;
    }

    this.onSelectOption(this.EventEmitter({
      loan: this.loanObject,
      loanId: this.loanObject.identifying,
    }));

    this.onChangeOptionSelected(this.EventEmitter({
      optionSelected: LOANS_MODAL_STATES.CADASTRAL_REFERENCE,
    }));

    if (!this.isMobileApp) {
      return $(MODALS.MY_LOANS).modal({backdrop: 'static', keyboard: false});
    }

    const dataParams = {
      loan: this.loanObject,
      from: 'my-loans'
    };

    this.state.go(STATES.LOANS.CADASTRAL_REFERENCE, {dataParams});
  }
}

export default MyLoansCardController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoansCard/myLoansCard.controller.js